import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	listMigrationSuccessFlag: {
		id: 'issue-navigator.services.list-nin-config-migration.show-flag.success.list-migration-success.nonfinal',
		defaultMessage: 'Updated view settings',
		description: 'Success message when list migration is successful',
	},
	listMigrationErrorFlag: {
		id: 'issue-navigator.services.list-nin-config-migration.show-flag.error.list-migration-error.nonfinal',
		defaultMessage: "We can't update your view settings",
		description: 'Error message when list migration fails',
	},
	listMigrationTryAgainAction: {
		id: 'issue-navigator.services.list-nin-config-migration.show-flag.error.list-migration-try-again-action.nonfinal',
		defaultMessage: 'Try again',
		description: 'Action to try again when list migration fails',
	},
	listMigrationInProgressTitle: {
		id: 'issue-navigator.services.list-nin-config-migration.show-flag.info.list-migration-in-progress-title.nonfinal',
		defaultMessage: 'Updating view settings',
		description: 'Title when updating view settings is in progress',
	},
	listMigrationInProgressDescription: {
		id: 'issue-navigator.services.list-nin-config-migration.show-flag.info.list-migration-in-progress-description.nonfinal',
		defaultMessage: 'Stay on this page until the update is finished.',
		description: 'Description when updating view settings is in progress',
	},
});
export default messages;
